export const messages = {
  pl: {
    message: {
      montaz_central: 'Montaż Central',
      wroc: 'wróć',
      centrale: 'Centrale',
      moduly: 'Moduły',
      dopasowanie_obudowy: 'Dopasowanie obudowy do centrali / modułu',
      dopasowanie_centrali: 'Dopasowanie centrali / modułu do obudowy',
      widok: 'widok',
      wybrana_obudowa: 'Wybrana obudowa',
      centrala_moduly: 'Centrala / moduły',
      dopasowane_obudowy: 'Dopasowane obudowy',
      producent: 'Producent',
      centrala: 'Centrala',
      modul: 'Moduł',
      brak_obudow: 'brak obudów dla zadanych parametrów',
      strona_produktowa: 'Strona produktowa na www:',
      zobacz: 'zobacz',
      rodzaj_montazu: 'Rodzaj montażu',
      natynkowa: 'natynkowa',
      podtynkowy: 'podtynkowy',
      trafo_zasilacz: 'Transformator / Zasilacz',
      akumulator: 'Akumulator',
      obudowa: 'Obudowa'
    }
  },
  en: {
    message: {
      montaz_central: 'Installation of control panels',
      wroc: 'back',
      centrale: 'Control panels',
      moduly: 'Modules',
      dopasowanie_obudowy: 'Fitting the housing to the control panel',
      dopasowanie_centrali: 'Matching the control panel / module to the housing',
      widok: 'view',
      wybrana_obudowa: 'Enclosures selected',
      centrala_moduly: 'Control panel / module',
      dopasowane_obudowy: 'Matched enclosures',
      producent: 'Producer',
      centrala: 'Central',
      modul: 'Module',
      brak_obudow: 'results empty',
      strona_produktowa: 'Product page on www:',
      zobacz: 'see',
      rodzaj_montazu: 'Mounting type',
      natynkowa: 'surface mounted',
      podtynkowy: 'flush-mounted',
      trafo_zasilacz: 'Transformers / Power supply units',
      akumulator: 'Battery',
      obudowa: 'Enclosure'
    }
  }
}








// WEBPACK FOOTER //
// ./src/translations/messages.js